import React, { useContext } from "react";
import classNames from "classnames";
import GlobalContext from "../../../context/global";
import { useMenuItemsStore } from "../../../../stores";
import VerifiedMutedIcon from "./VerifiedMutedIcon";

const getMenuItems = (
  product,
  svtQuestions,
  displayStep3,
  showAddress,
  isCDTT,
) => {
  if (!product) return [];
  if (product === "credit") {
    return [
      {
        description: "Your Name",
        state: "credit.home",
        isActive: false,
      },
      {
        description: "Your ZIP Code",
        state: "credit.form.zipcode",
        isActive: false,
      },
      {
        description: "Your Info",
        state: "credit.form.address",
        isActive: false,
      },
      {
        description: "Your Next Vehicle",
        state: "credit.form.vehicle",
        isActive: false,
      },
    ];
  }

  if (product === "trade") {
    const stepOneDescription =
      isCDTT && showAddress ? "Your Car" : "Your Vehicle";
    const stepThreeDescription =
      isCDTT && !showAddress ? "Your Next Vehicle" : "Your Info";
    const defaultMenuItems = [
      {
        description: stepOneDescription,
        state: "trade.home",
        isActive: false,
      },
      {
        description: "Your Options",
        state: "trade.form.equipment",
        isActive: false,
      },
    ];
    svtQuestions &&
      defaultMenuItems.push({
        description: "Vehicle Condition",
        state: "trade.form.questions",
        isActive: false,
      });
    displayStep3 &&
      defaultMenuItems.push({
        description: stepThreeDescription,
        state: "trade.form.aboutYou",
        isActive: false,
      });
    return defaultMenuItems;
  }
};

const MenuSteps = () => {
  const appData = useContext(GlobalContext);
  const {
    dealerProfile: {
      product,
      svt,
      customStyle,
      displayStep3,
      features: { showAddress },
    },
    appState: { current },
    isCDTT,
  } = appData;
  const svtQuestions = svt === "questions";
  const menuItems = getMenuItems(
    product,
    svtQuestions,
    displayStep3,
    showAddress,
    isCDTT,
  );

  let currentIndex;

  if (current.data?.step) {
    if (svtQuestions && current.name === "trade.form.aboutYou") {
      currentIndex = current.data.step;
    } else {
      currentIndex = current.data.step - 1;
    }
    if (currentIndex < menuItems.length) {
      menuItems[currentIndex].isActive = true;
    }
  }

  if (current.name?.includes(".results")) {
    currentIndex = 5;
  }

  useMenuItemsStore.set({ items: menuItems });

  const defaultCarAndDriverMenuSteps = () => (
    <div
      className={classNames("menu-steps p-0", {
        "my-0": isCDTT,
      })}
    >
      {menuItems.map((menuItem, index) => {
        const step = `Step ${index + 1}`;
        const description = isCDTT
          ? `${index + 1}. ${menuItem.description.toUpperCase()}`
          : menuItem.description;
        return (
          <div
            key={index}
            className={classNames(
              "menu-steps-item d-flex align-items-center menu-steps-item--border",
              {
                active: menuItem.isActive,
                selected: index < currentIndex,
                "not-results-page": currentIndex < 5,
              },
            )}
          >
            <span className="m-auto text-align-center">
              {!isCDTT && <div className="title fw-bold">{step}</div>}
              <div
                className={classNames("description", {
                  "description--narrow": isCDTT && !showAddress,
                })}
              >
                {description}
              </div>
            </span>
          </div>
        );
      })}
    </div>
  );

  const whiteLabelCarAndDriverMenuSteps = () => (
    <div className="menu-steps p-0">
      {menuItems.map((menuItem, index) => (
        <div
          key={index}
          className={classNames(
            "menu-steps-item d-flex align-items-center menu-steps-item--border",
            {
              "active-white-label": menuItem.isActive,
              "not-results-page-white-label": currentIndex < 5,
            },
          )}
        >
          <span className="m-auto text-align-center">
            <div>
              <div className="title fw-bold">Step {index + 1}</div>
              <div className="description">{menuItem.description}</div>
            </div>
          </span>
          <div className="pb-4 pe-3">
            {index < currentIndex && <VerifiedMutedIcon />}
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div
      className={classNames("row header-menu", {
        "hide-on-mobile": svtQuestions,
        "header-menu-default": !customStyle && !isCDTT,
        "cd2-menu-default": !customStyle,
      })}
    >
      {!customStyle && defaultCarAndDriverMenuSteps()}
      {customStyle && whiteLabelCarAndDriverMenuSteps()}
    </div>
  );
};

export default MenuSteps;
